import {gsap} from "gsap";
import {createBrowserHistory} from "history";

let History = createBrowserHistory();

const ServisForm = {

    init() {
        this.el = $('[component="ServisForm"]');
        if (!this.el.length) return;

        this.select = this.el.find('select[name="serviceType"]');
        this.expander = this.el.find('.expander');
        this.headline = this.el.closest('[block]').find('h1');
        this.datalayerEvent = this.el.find('input[type="hidden"][name="datalayer_event"]');
        this.bind();
        this.setTypeByUrl();
    },

    bind() {
        this.select.change((evt) => {
            const val = $(evt.currentTarget).val();
            this.setType(val);

            if (val === 'ine') {
                this.show();
            } else {
                this.hide();
            }
        })
    },

    show() {
        gsap.set(this.expander, {height: 'auto'})
        gsap.from(this.expander, {height: 0})
    },

    hide() {
        gsap.to(this.expander, {height: 0})
    },

    setType(val) {
        let newUrl;
        let url = window.location.pathname;
        let type = serviceTypes.filter((item) => item.url === val)[0];
        if (!type) type = serviceTypes[0];
        const oldUrl = url.split('/').pop();
        const hasChild = serviceTypes.filter((item) => item.url === oldUrl).length > 0;

        if (hasChild) {
            newUrl = url.replace(oldUrl, type.url)
        } else {
            newUrl = url + '/' + type.url
        }

        History.push(newUrl, null);
        this.setHeadline(type);
        this.datalayerEvent.val("servis_" + val);

        // console.log(oldUrl, type.url, newUrl)
        // window.location.href = newUrl
    },

    setTypeByUrl() {
        const url = window.location.pathname.split('/').pop();
        let type = serviceTypes.filter((item) => item.url === url)[0];
        const menuItem = $('[component="Header"] [method="renderMenu"]').find('a[href*="' + url + '"]').closest('li');

        if (!type) {
            type = {
                name: this.headline.attr('title'),
                icon: this.headline.attr('image-icon')
            }
        } else {
            this.select.val(type.url).trigger('chosen:updated');
            this.select.prevAll('input[name="serviceType_name"]').val(type.name);
            this.select.prevAll('input[name="serviceType_icon"]').val(type.icon);
            this.el.find('input[name="datalayer_event"]').val("servis_" + type.url);
            menuItem.siblings().removeClass('selected');
            menuItem.addClass('selected');
        }

        this.setHeadline(type);
    },

    setHeadline(type) {
        this.headline.text(type.name);
        $('<img>').attr('src', '/templates/src/Assets/icons/icon.' + type.icon + '.svg').prependTo(this.headline);
        this.headline.css({opacity: 1})
    }
}

export default ServisForm;